import { ReactNode } from "react";
import { Navigate, useNavigate } from "react-router-dom";
// components
import LoadingScreen from "../components/loading-screen";
//
import { useAuthContext } from "./useAuthContext";
import { PATH_AFFILIATE, PATH_SALES } from "../routes/paths";
import { NavigationSteps, TabsData } from "../utils/common";

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { user, isAffiliate, isAuthenticated, isInitialized } =
    useAuthContext();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated && user.userType === "salesUser") {
    return <Navigate to={PATH_SALES.dashboard} />;
  }

  if (isAuthenticated && isAffiliate) {
    return <Navigate to={PATH_AFFILIATE.dashboard} />;
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={
          NavigationSteps.find((item) =>
            item.status.includes(user?.profileStatus || 0)
          )?.url || ""
        }
      />
    );
  }

  return <>{children}</>;
}
